import * as React from 'react'
import { Box, List, ListItem, ListItemButton, ListItemText, Menu } from '@mui/material'

import { useUiLanguageLabel } from '@/locales/uiLanguages'
import {
  languageMenuPaperStyles,
  listItemButtonStyles,
  listItemTextStyles,
  checkmarkStyles,
} from './MobileNavBarStyles'

type Language = {
  tag: string
  display_name: string
}

type LanguageMenuProps = {
  anchorEl: HTMLElement | null
  languages: Language[]
  currentLanguage: string
  onClose: () => void
  onLanguageChange: (languageCode: string, event: React.MouseEvent<HTMLElement>) => void
}

export const LanguageMenu = ({
  anchorEl,
  languages,
  currentLanguage,
  onClose,
  onLanguageChange,
}: LanguageMenuProps) => {
  const languageLabel = useUiLanguageLabel()

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      disableRestoreFocus
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: languageMenuPaperStyles,
        },
      }}>
      <List sx={{ py: 1 }}>
        {languages.map(({ tag, display_name }) => {
          const isSelected = tag === currentLanguage
          return (
            <ListItem key={tag} disablePadding>
              <ListItemButton
                component="div"
                selected={isSelected}
                onClick={(e) => onLanguageChange(tag, e)}
                sx={listItemButtonStyles}>
                <ListItemText primary={languageLabel(tag, display_name)} sx={listItemTextStyles(isSelected)} />
                {isSelected && <Box sx={checkmarkStyles}>✓</Box>}
              </ListItemButton>
            </ListItem>
          )
        })}
      </List>
    </Menu>
  )
}
